import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Col, Row } from "reactstrap";

// eslint-disable-next-line react/prop-types
const BreadCrumb = ({ title, pageTitle }) => {

  const location = useLocation();

  useEffect(() => {
    document.title = title + " | " + process.env.REACT_APP_NAME;
  }, [location, title]);

  return (
    <React.Fragment>
      <Row className="g-0">
        <Col xs={12} className="px-0">
          <div className="page-title-box app-breadcrumb-spacing d-flex align-items-center flex-wrap gap-2 gap-sm-3 py-sm-2 py-3 pt-sm-2 pt-4 justify-content-between">
            <h4 className="mb-0 flex-shrink-0">{pageTitle}</h4>

            <div className="page-title-right flex-shrink-0 ms-sm-auto">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">{pageTitle}</Link>
                </li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
